
<template>
<b-container class="bv-example-cambioc500">
        <b-img class="logooc500" :src="logo"></b-img>
           <b-row>
             <b-col cols="6" class="contenido-login500">
             <b-img class="caraa500" :src="cara"></b-img>
             <label class="number500">500</label>
             </b-col>
             <b-col cols="6" class="contenido-login500s" >
                <h6 class="poppins-semi-bold-orange-white-20px">Error 500</h6>
                <h1 class="no-encontramos-lap500">Error interno del <br> servidor...<br></h1>
                <h5 class="poppins-semi-bold-orange-white-20px">No se pudo establecer la conexión con el servidor.</h5>
             </b-col>
            </b-row>
</b-container>
  
</template>

<script>

export default {
  name: "Error500",
   components: {},
  
  props: [
    "logo",
    "cara",
    "desgrade",
  ],
  data() {
        return {
           
        }
    },
   methods: {
        
       
    }, 
};

</script>

<style>
.number500 {
    color: var(--blue-violet);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-xll);
    font-weight: 600;
    letter-spacing: 0;
    line-height: 36px;
    white-space: nowrap;
    margin-top: 12%;
    margin-left: -12%;
    position:absolute;
}
.bv-example-cambioc500 {
    background-color: var(--blue-violet);
    margin: 0;
    max-width: 100% !important;
    height: 753px !important;
     text-align: center;
}
.logooc500 {
    margin-top: 3%;
}
.no-encontramos-lap500 {
  color: var(--orange-white);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-ll);
  font-weight: 600;
  letter-spacing: 0;
  line-height: 60px;
  margin-top: 4%;
  margin-bottom: 1%;
  min-height: 138px;
  white-space: nowrap;
}
.contenido-login500s{
  text-align:left;
  margin-top:9% !important;
}
.boton-ingresoo500{
    margin-top:3%;
    width:36%;
    background-color: var(--white) !important;
    border-radius: 10px !important;
    height: 50px;
    text-align: center;
    border-color:transparent !important ;
}
.boton-ingresoo500:hover{
    background: var(--hawkes-blue) !important;
}
.ir-al-inicio-de-sesin500 {
    color: var(--blue-violet);
    font-family: var(--font-family-poppins);
    font-size: var(--font-size-sl);
    font-weight: 600;
    letter-spacing: 0;
    line-height: 14px;
    
}
.caraa500{
      margin-top: 17%;
    margin-left: 27%;
}
@media (max-width: 1922px) {
.bv-example-cambioc500 {
    height: 969px !important;
}
.number500 {
        margin-top: 11.5%;
    margin-left: -9.5%;
}
}
@media (max-width: 1540px) {
.bv-example-cambioc500 {
    height: 753px !important;
}
.number500 {
   margin-top: 9.5%;
    margin-left: -12%;
}
.caraa500{
    margin-top: 11%;
}
}
@media (max-width: 1370px) {
        .logooc500 {
    margin-top: 2%;
    width: 16%;
}
.caraa500 {
    margin-top: 13%;
    width: 50%;
}
.contenido-login500s {
    margin-top: 7% !important;
}
.number500 {
    margin-top: 10%;
    margin-left: -12.3%;
}
    }
@media (max-width: 1280px) {
  .bv-example-cambioc500 {
    height: 609px !important;
}
.contenido-login500s {
    margin-top: 7% !important;
}
.number500 {
        margin-top: 10%;
    margin-left: -12.5%;
}
}
@media (max-width: 1100px) {
   .bv-example-cambioc500 {
    height: 506px !important;
}
.caraa500 {
    margin-top: 12%;
    width: 54%;
}
.no-encontramos-lap500 {
    font-size: 40px;
    margin-top: 2%;
    margin-bottom: 2%;
}
.boton-ingresoo500 {
    margin-top: 2%;
    height: 37px;
}
}
</style>